import { Component, OnInit,ViewChild } from '@angular/core';
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
import { ThrowStmt } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ActivatedRoute,Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver';


@Component({
  selector: 'app-fmthk',
  templateUrl: './fmthk.component.html',
  styleUrls: ['./fmthk.component.scss']
})
export class FmthkComponent implements OnInit {

  constructor(public authService: AuthService,public router: Router) { }

  ngOnInit() {
    var t= localStorage.getItem("t_hk");
    console.log(t);
    switch (t) {      
      case 'P':
        break;
      case 'X':
        this.id_hk=Number(localStorage.getItem("id_hk"));
        this.nivel=Number(localStorage.getItem("nivel"));
        this.duenio_id=Number(localStorage.getItem("duenio_id"));
        this.duenio=(localStorage.getItem("duenio"));
        this.fecha=localStorage.getItem("fecha");
        this.supervisor=localStorage.getItem("supervisor");
        this.generateExcel();
          break;    
      default:
        break;
    }
  }
  supervisor;
  tarea;
  nivel=1;
  id_hk=0;
  evl;
  Sup;
  Inf;
  LI;
  LD;
  Resp;
  duenio_id=0;
  fecha;
  duenio="";
  img_g5;
  si_id;
  check_pa(e,si,id){
    var val="";
    var bndc="";
    //console.log("fn check e:"+e+"-si:"+si+"-id:"+id);
    //console.log(this.si_id)    
    for(var i=0;i<this.si_id.length;i++){
      if(this.nivel==1){
        if(this.si_id[i].e==e && this.si_id[i]._si==si && this.si_id[i]._id==id){
          val=this.si_id[i].valor;
          if(this.si_id[i].c==1)bndc="X";
        }
      }else{
        if(this.si_id[i].e==e && 
          this.si_id[i]._si==si && 
          this.si_id[i]._id==id && 
          this.si_id[i].responsable==this.duenio_id){
          val=this.si_id[i].valor;
          if(this.si_id[i].c==1)bndc="X";
        }
      }
      
    }
    if(e==5){
      return val;
    }
    return bndc;
  }
  
  
  async generateExcel(){
    let workbook = new Excel.Workbook();
    let worksheet = workbook.addWorksheet('HK');
    //Add Row and formatting
 
 
    var raciname;
    let postData={
      id:this.id_hk
    }    
    await  this.authService.service("/api/get_hk_id",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);             
          raciname=res[0].nombre;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)      
     });  
     this.Sup=[];
     this.Resp=[];
     this.LI=[];
     this.LD=[];
     this.Inf=[];
     let postData2 = {
       id_hk:this.id_hk,  
       nivel:this.nivel  
     }
    
     await this.authService.service("/api/getevl_hk",postData2)
     .then(
       data => {
         var dat = JSON.stringify(data);
         var res = JSON.parse(dat);  
         this.evl=res;   
         //console.log(this.evl)     
         if(res.length>0){
           switch (Number(this.nivel)) {
             case 1:        
               for(var i=0;i<this.evl.length;i++){
                 
                 //console.log(this.evl.length)
                 //console.log(this[i]);
                 if(Number(this.evl[i].lado)==1){
                   if(this.evl[i].nivel==this.nivel)
                   this.Sup.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
                 }
                 if(Number(this.evl[i].lado)==2){
                   if(this.evl[i].nivel==this.nivel)
                   this.LD.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
                 }
                 if(Number(this.evl[i].lado)==3){
                   if(this.evl[i].nivel==this.nivel)
                   this.Inf.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
                 }
                 if(Number(this.evl[i].lado)==4){
                   if(this.evl[i].nivel==this.nivel)
                   this.LI.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
                 }
                 if(Number(this.evl[i].lado)==5){
                   if(this.evl[i].nivel==this.nivel)
                   this.Resp.push({des:this.evl[i].persona,id:this.evl[i].id,lado:this.evl[i].lado});
                 }
               }     
               break;
             default:        
             //console.log("dueño "+this.duenio_id);

               for(var i=0;i<this.evl.length;i++){
                 if(Number(this.evl[i].lado)==1 && this.evl[i].nivel==this.nivel){
                   if( Number(this.evl[i].responsable)==Number(this.duenio_id))
                   this.Sup.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
                  //console.log("nivel} -"+this.duenio_id+"-"+this.evl[i].responsable)
                 }
                 if(Number(this.evl[i].lado)==2){
                   if(this.evl[i].nivel==this.nivel)
                   if( Number(this.evl[i].responsable)==Number(this.duenio_id))
                   this.LD.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
                 }
                 if(Number(this.evl[i].lado)==3){
                   if(this.evl[i].nivel==this.nivel)
                   if( Number(this.evl[i].responsable)==Number(this.duenio_id))
                   this.Inf.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
                 }
                 if(Number(this.evl[i].lado)==4){
                   if(this.evl[i].nivel==this.nivel)
                   if( Number(this.evl[i].responsable)==Number(this.duenio_id))
                   this.LI.push({des:this.evl[i].nombre,id:this.evl[i].id,lado:this.evl[i].lado});
                 }
                 if(Number(this.evl[i].lado)==5){
                   //console.log(this.evl[i]);
                   if(Number(this.evl[i].nivel)==this.nivel){              
                     if( Number(this.evl[i].responsable)==Number(this.duenio_id)){              
                     //console.log("ok"+this.evl[i].id);
                     this.Resp.push({des:this.evl[i].persona,id:this.evl[i].id,lado:this.evl[i].lado});
                     }
                   }
                   
                 }
               }
               break;
           }       
         }
       },
       error => {
           var de= JSON.stringify(error);
           var di = JSON.parse(de)
           //swal.fire('¡Información incorrecta!', '', 'error');
       }); 
 
    let postData3={
        img:"hk.png"
    }
    await this.authService.service("/api/img_g4",postData3)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  

        this.img_g5="data:image/jpeg;base64,"+res.img;
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        //swal.fire('¡Información incorrecta!', '', 'error');
    });
    
     let postDatas = {
      id_hk:this.id_hk,
      nivel:this.nivel
    }
    //console.log(postData);
    await this.authService.service("/api/get_r_hk",postDatas)
      .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        //console.log(data);
        this.si_id=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
         // swal.fire('¡Información incorrecta!', '', 'error');
      });     
    //----------------------------------------
    const imageId = workbook.addImage({
      base64: this.img_g5,
      extension: 'png',
    });

  const title = 'Hoshin Kanri: '+raciname;    
  let titleRow = worksheet.addRow([title]);
  titleRow.font = { name: 'Arial', family: 4, size: 16, underline: 'double', bold: true }
 
  
  worksheet.addRow([]);     
      for(var i=0;i<this.Sup.length;i++){
        var rr=[]
        for(var j=0;j<this.LI.length;j++){
          rr.push(this.check_pa(1,this.Sup[i].id,this.LI[j].id));
        }
        rr.push(this.Sup[i].des);
        for(var k=0;k<this.LD.length;k++){
          rr.push(this.check_pa(2,this.Sup[i].id,this.LD[k].id));
        }
        for(var k=0;k<this.Resp.length;k++){
          rr.push(this.check_pa(5,this.Sup[i].id,this.Resp[k].id));
        }
        //console.log(rr)
        let row = worksheet.addRow(rr);   
        row.eachCell((cell, number) => {
          switch (cell.value) {
            case 'X':
            case 'R':
            case 'RS':case 'Rs':case '':
              cell.font={ color:{argb:'#000000'} ,size: 12}; 
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFFF' },              
              }
              cell.alignment={horizontal:"center",wrapText: true}          
              break;       
            default:
              cell.font={ color:{argb:'#ffffff'} ,size: 12}; 
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'B5CBE1' },              
              }
              cell.alignment={horizontal:"center",wrapText: true} 
              break;
          }                
          cell.border = { top: { style: 'thin' , color: {argb:'000000'} }, 
              left: { style: 'thin' , color: {argb:'000000'} }, 
              bottom: { style: 'thin' }, 
              right: { style: 'thin', color: {argb:'000000'} } }                 
        })
      
      }
      
      //----------------------------------------
      var rr2=[];
      for(var j=0;j<this.LI.length;j++){
        rr2.push(this.LI[j].des);
      }
      rr2.push("");
      
      for(var j=0;j<this.LD.length;j++){
        rr2.push(this.LD[j].des);
      }
      for(var j=0;j<this.Resp.length;j++){
        rr2.push(this.Resp[j].des);
      }
      let row=worksheet.addRow(rr2); 
      row.height = 210;
      worksheet.addImage(imageId, { tl: 
          { col: this.LI.length, 
            row: this.Sup.length+2.5}, ext: { 
              width: 490,
              height: 260 
            }});
      row.eachCell((cell, number) => {
        
        //console.log("n"+number+"--"+cell.value);
        var color_='f5dca6' ;
        if(number<=this.LI.length){
           color_='f5dca6' ;
           cell.alignment={horizontal:"left" ,textRotation: -90,wrapText: true} 
        }else if(number==this.LI.length+1){
          color_='' ;
          
        }else if(number>(this.LI.length+1) && number<=(this.LD.length+1+this.LI.length)){
          color_='C2CFAD' ;
          cell.alignment={horizontal:"right" ,textRotation: -90,wrapText: true} 
        }else{
          cell.alignment={horizontal:"right" ,textRotation: -90,wrapText: true} 
          color_='add8e6';
        }
        cell.font={ color:{argb:'#ffffff'} ,size: 8}; 
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb:color_ },              
        }                              
        
        cell.border = { top: { style: 'thin' , color: {argb:'000000'} }, 
            left: { style: 'thin' , color: {argb:'000000'} }, 
            bottom: { style: 'thin' }, 
            right: { style: 'thin', color: {argb:'000000'} } }                 
      })
      
      //----------------------------------------
      
      for(var i=0;i<this.Inf.length;i++){
        var rr3=[];
        for(var j=0;j<this.LI.length;j++){
          rr3.push(this.check_pa(3,this.Inf[i].id,this.LI[j].id))
        }
        rr3.push(this.Inf[i].des);;                    
      let row2=worksheet.addRow(rr3); 
      row2.eachCell((cell, number) => {
       //console.log("n"+number+"--"+cell.value);
        var color_='' ;
        if(number==(this.LI.length+1)){
           color_='DECD98' ;
        }else{
          color_='';
        }
        cell.font={ color:{argb:'#ffffff'} ,size: 12}; 
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb:color_ },              
        }               
        cell.alignment={horizontal:"center",wrapText: true} 
        cell.border = { top: { style: 'thin' , color: {argb:'000000'} }, 
            left: { style: 'thin' , color: {argb:'000000'} }, 
            bottom: { style: 'thin' }, 
            right: { style: 'thin', color: {argb:'000000'} } }                 
      })
    }
    
    let titleRow2 = worksheet.addRow(["Level:",this.nivel]);
    titleRow2.eachCell((cell, number) => {cell.font={ color:{argb:'ffffff'} ,size: 12}; cell.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb:"000000" }}});
    let titleRow3 = worksheet.addRow(["Owner:",this.duenio]);
    titleRow3.eachCell((cell, number) => {cell.font={ color:{argb:'ffffff'} ,size: 12}; cell.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb:"000000" }}});
    let titleRow4 = worksheet.addRow(["Fecha:",this.fecha]);
    titleRow4.eachCell((cell, number) => {cell.font={ color:{argb:'ffffff'} ,size: 12}; cell.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb:"000000" }}});
    let titleRow5 = worksheet.addRow(["Revisado por:",this.supervisor]);
    titleRow5.eachCell((cell, number) => {cell.font={ color:{argb:'ffffff'} ,size: 12}; cell.fill = {type: 'pattern',pattern: 'solid',fgColor: { argb:"000000" }}});
    for(var j=1;j<=this.LI.length;j++){
      worksheet.getColumn(j).width = 10;  
    }
    worksheet.getColumn(this.LI.length+1).width = 70;    
    worksheet.addRow([]);
    let footerRow = worksheet.addRow(['Report V1.']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    //Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'CarData.xlsx');
    });  
    setTimeout(function(){
      window.close();
    },4000);


  }
}
